import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/reset.svg";
var ResetSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ResetSolid_default as default
};
